export default __webpack_public_path__ + "static/media/typebus.e55b9eec.svg";